module.exports = "//static.hsappstatic.net/LearningCenterUI/static-1.12597/images/pngs/practical_exercise_thumbnail.png"